<eo-base-form-control
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicableLabel]="notApplicableLabel"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <ng-content />
</eo-base-form-control>
